import { useMutation } from "react-query";
import { updateLeasedEquipmentSupplyAlertProfile } from "../../../../../actions/Utilities/LeasedEquipmentSupplyAlertProfile";
import { toast } from "components/toastNotification";
import { ISupplyAlertProfile } from "../types";

const useEditSupplyAlertProfile = () => {
    const { mutate } = useMutation(
        (Data: ISupplyAlertProfile) => updateLeasedEquipmentSupplyAlertProfile(Data),
        {
            onSuccess: (res) => {
                switch (true) {
                    case res == "Success":
                        toast.fire("Success", "Supply Alert Profile Updated Successfully", "success");
                        break;
                    case res.includes("Notification insert Failed"):
                        toast.fire(
                            "Success ",
                            `Supply Alert Profile Updated Successfully, BUT ${res}`,
                            "warning"
                        );
                        break;
                    case res == "Operation Failed!":
                        toast.fire(
                            "Updating Supply Alert Profile failed ",
                            `Server Error: ${res}`,
                            "error"
                        );
                        break;
                    case res == "The data already exists!":
                        toast.fire(
                            "Updating Supply Alert Profile failed ",
                            `Duplication Error: ${res}`,
                            "error"
                        );
                        break;
                    case res.includes("Action object"):
                        toast.fire("Updating Supply Alert Profile failed ", `Error: ${res}`, "error");
                        break;
                    default:
                        toast.fire("Updating Supply Alert Profile failed", `${res.Message}`, "error");
                }
            },
            onError: (error: any) => {
                toast.fire("Update Supply Alert Profile failed", `Error: ${error}`, "error");
            },
        }
    );
    return mutate;
};

export default useEditSupplyAlertProfile;
